import { GridColDef } from '@mui/x-data-grid'

import { ColumnChipList, ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: GridColDef<GridRow>[] = [
  {
    headerName: 'ФИО',
    field: 'name',
    sortable: false,
    flex: 1,
    minWidth: 240,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'E-mail',
    field: 'email',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'Часовой Пояс',
    field: 'timezone',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'Роли',
    field: 'rolesIds',
    sortable: false,
    flex: 1,
    minWidth: 220,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
]
